import { Flex, Image, Text } from '@chakra-ui/react';
import { EventTopic } from 'model/modules/events/eventCategory';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  topics: EventTopic[];
}

const EventDetailTopics: FC<Props> = ({ topics }) => {
  const { t } = useTranslation();

  const gap = 20;

  return (
    <>
      <GridHeading>{t('eventTopics')}</GridHeading>
      <AppCard
        py="10px"
        px="20px"
        display="flex"
        flexWrap="wrap"
        justifyContent="space-between"
      >
        {topics.map((topic, index) => {
          return (
            <Flex key={index} w={`calc(50% - ${gap / 2}px)`} py="10px">
              <Image w="40px" h="40px" src={topic.icon} mr="15px" />
              <Flex flexDir="column" justifyContent="center">
                <Text fontSize="12px" mb="5px">
                  {topic.title}
                </Text>
                <Text fontWeight={700}>{topic.subtitle}</Text>
              </Flex>
            </Flex>
          );
        })}
      </AppCard>
    </>
  );
};

export default EventDetailTopics;
